import { forwardRef, useContext } from 'react';
import { Styled } from './Controls.styles';
import Button from '../../Button';
import IconButton from '../../IconButton';
import { FeatureHeaderContext } from '../FeatureHeader';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var useFeatureHeaderContext = function useFeatureHeaderContext() {
  return useContext(FeatureHeaderContext);
};

var Controls = forwardRef(function (_ref, ref) {
  var _actions$start$label, _actions$start, _actions$previous$tit, _actions$previous, _actions$next$title, _actions$next, _actions$end$label, _actions$end;

  var activeIndex = _ref.activeIndex,
      actions = _ref.actions,
      hasStartAction = _ref.hasStartAction,
      goToSlide = _ref.goToSlide,
      slideCount = _ref.slideCount;

  var _useFeatureHeaderCont = useFeatureHeaderContext(),
      level = _useFeatureHeaderCont.level;

  var buttonMode = level === 'one' ? 'dark' : level === 'two' ? 'light' : 'light';
  var showStart = (actions === null || actions === void 0 ? void 0 : actions.start) && activeIndex === 0;
  var showEnd = slideCount > 1 && (actions === null || actions === void 0 ? void 0 : actions.end) && activeIndex === slideCount - 1;
  var showPrev = slideCount > 1 && !showStart;
  var showNext = slideCount > 1 && !showStart && !showEnd;
  return _jsxs(Styled.Controls, {
    ref: ref,
    children: [showStart && _jsx(Button, {
      mode: buttonMode,
      variant: "primary",
      onClick: function onClick() {
        slideCount > 1 && goToSlide(activeIndex + 1);
        actions.start.onClick && actions.start.onClick();
      },
      children: (_actions$start$label = actions === null || actions === void 0 ? void 0 : (_actions$start = actions.start) === null || _actions$start === void 0 ? void 0 : _actions$start.label) !== null && _actions$start$label !== void 0 ? _actions$start$label : 'Get started'
    }), showPrev && _jsx(IconButton, {
      mode: buttonMode,
      variant: "secondary",
      icon: "chevron-left",
      onClick: function onClick() {
        goToSlide(activeIndex - 1);
        actions.previous.onClick && actions.previous.onClick();
      },
      isDisabled: activeIndex === 0,
      title: (_actions$previous$tit = actions === null || actions === void 0 ? void 0 : (_actions$previous = actions.previous) === null || _actions$previous === void 0 ? void 0 : _actions$previous.title) !== null && _actions$previous$tit !== void 0 ? _actions$previous$tit : 'Previous'
    }), showNext && _jsx(IconButton, {
      mode: buttonMode,
      variant: "secondary",
      icon: "chevron-right",
      onClick: function onClick() {
        goToSlide(activeIndex + 1);
        actions.next.onClick && actions.next.onClick();
      },
      isDisabled: activeIndex === slideCount - 1,
      title: (_actions$next$title = actions === null || actions === void 0 ? void 0 : (_actions$next = actions.next) === null || _actions$next === void 0 ? void 0 : _actions$next.title) !== null && _actions$next$title !== void 0 ? _actions$next$title : 'Next'
    }), showEnd && _jsx(Button, {
      mode: buttonMode,
      variant: "primary",
      onClick: function onClick() {
        return actions.end.onClick ? actions.end.onClick() : null;
      },
      children: (_actions$end$label = actions === null || actions === void 0 ? void 0 : (_actions$end = actions.end) === null || _actions$end === void 0 ? void 0 : _actions$end.label) !== null && _actions$end$label !== void 0 ? _actions$end$label : 'Finish'
    })]
  });
});
export default Controls;